export const thunkTypes = {
  LIST_USERS: `users/listUsers`,
  LIST_ROLES: `users/listRoles`,
  LIST_ZONES: `users/listZones`,
  CREATE_USER: `users/createUser`,
  UPDATE_USER: `users/updateUser`,
};
